import "./web.df5bad77.js";
import "./web.1b47896f.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea073"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea073"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6dhn9", function(module, exports) {

$parcel$export(module.exports, "ParseDateOnly", () => $92f0f3dedfaa8a18$export$10df58c66de508e2);
$parcel$export(module.exports, "FormatDate", () => $92f0f3dedfaa8a18$export$68962dbd27cd2e36);
const $92f0f3dedfaa8a18$var$MONTHNAME = [
    'januar',
    'februar',
    'mars',
    'april',
    'mai',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'desember'
];
function $92f0f3dedfaa8a18$var$GetShortMonthName(month_idx) {
    let name = $92f0f3dedfaa8a18$var$MONTHNAME[month_idx];
    if (name.length > 4) name = name.substring(0, 3) + '.';
    return name;
}
function $92f0f3dedfaa8a18$export$10df58c66de508e2(input) {
    const timeSeparatorIndex = input.indexOf("T");
    if (timeSeparatorIndex > -1) return new Date(input.substring(0, timeSeparatorIndex));
    return new Date(input);
}
function $92f0f3dedfaa8a18$export$68962dbd27cd2e36(d, format) {
    let out = '';
    for(let i = 0; i < format.length; ++i){
        switch(format[i]){
            case 'H':
                if (format.length > i + 1 && format[i + 1] == 'H') {
                    out += d.getHours().toString().padStart(2, '0');
                    i++;
                    continue;
                }
                break;
            case 'M':
                if (format.length > i + 1 && format[i + 1] == 'M') {
                    out += d.getMinutes().toString().padStart(2, '0');
                    i++;
                    continue;
                }
                break;
            case 'S':
                if (format.length > i + 1 && format[i + 1] == 'S') {
                    out += d.getSeconds().toString().padStart(2, '0');
                    i++;
                    continue;
                }
                break;
            case 'd':
                if (format.length > i + 1 && format[i + 1] == 'd') {
                    out += d.getDate().toString().padStart(2, '0');
                    i++;
                    continue;
                }
                break;
            case 'm':
                let numConsecutive = 0;
                for(let j = i + 1; j < format.length; ++j){
                    if (format[j] == 'm') numConsecutive++;
                    else break;
                }
                switch(numConsecutive){
                    case 1:
                        out += (d.getMonth() + 1).toString().padStart(2, '0');
                        i += numConsecutive;
                        continue;
                    case 2:
                        out += $92f0f3dedfaa8a18$var$GetShortMonthName(d.getMonth());
                        i += numConsecutive;
                        continue;
                    case 3:
                        out += $92f0f3dedfaa8a18$var$MONTHNAME[d.getMonth()];
                        i += numConsecutive;
                        continue;
                }
                break;
            case 'y':
                if (format.length > i + 3 && format[i + 1] == 'y' && format[i + 2] == 'y' && format[i + 3] == 'y') {
                    out += d.getFullYear().toString().padStart(4, '0');
                    i += 3;
                    continue;
                }
            default:
                break;
        }
        out += format[i];
    }
    return out;
}

});


var $gzR1g = parcelRequire("gzR1g");

var $gizSK = parcelRequire("gizSK");
function $e85ebba489163d5f$export$6bae179d5738dc18(modalId) {
    const modalDiv = document.getElementById(modalId);
    const closeButton = modalDiv.getElementsByClassName('close')[0];
    closeButton.onclick = function() {
        modalDiv.style.display = 'none';
    };
    modalDiv.style.display = 'block';
    window.onclick = function(event) {
        if (event.target == modalDiv) modalDiv.style.display = "none";
    };
}



var $fckDn = parcelRequire("fckDn");
function $ef87980efebb2b46$export$d4eb4cc3b800a2f6() {
    let clientId = localStorage.getItem('client_id');
    if (clientId === null) {
        clientId = $ef87980efebb2b46$export$c267c46649295c8f(10);
        localStorage.setItem('client_id', clientId);
    }
    return clientId;
}
function $ef87980efebb2b46$export$c267c46649295c8f(length) {
    let result = '';
    let characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * charactersLength));
    return result;
}



var $hKsEd = parcelRequire("hKsEd");

var $6dhn9 = parcelRequire("6dhn9");
let $b4e14b6b8da86996$var$datatable = null;
let $b4e14b6b8da86996$var$webSocket = null;
let $b4e14b6b8da86996$var$currentLanguage = (0, $gizSK.GetInitialLanguage)();
window.onload = function() {
    $b4e14b6b8da86996$var$ReCreateDataTable();
    $b4e14b6b8da86996$var$StartListeners();
    document.getElementById('language-en-us').onclick = function() {
        $b4e14b6b8da86996$var$currentLanguage = (0, $gizSK.UpdateLanguage)('en-US', false);
        $b4e14b6b8da86996$var$ReCreateDataTable();
    };
    document.getElementById('language-nb-no').onclick = function() {
        $b4e14b6b8da86996$var$currentLanguage = (0, $gizSK.UpdateLanguage)('nb-NO', false);
        $b4e14b6b8da86996$var$ReCreateDataTable();
    };
    document.getElementById('more-info').onclick = function() {
        (0, $e85ebba489163d5f$export$6bae179d5738dc18)('more-info-modal');
    };
    $b4e14b6b8da86996$var$currentLanguage = (0, $gizSK.UpdateLanguage)($b4e14b6b8da86996$var$currentLanguage.code, true);
    (0, $fckDn.StartPingTimer)('index.html', function() {
        return {
            'language': $b4e14b6b8da86996$var$currentLanguage.code
        };
    });
};
// Caller must make sure that datatable.draw() is called.
function $b4e14b6b8da86996$var$AddTodayMarking() {
    // Remove any existing marker that may exists.
    let toRemove = [];
    $b4e14b6b8da86996$var$datatable.forEach(function(event) {
        if (event.is_today_marker) toRemove.push(event.event_id);
    }, (0, $hKsEd.ForEachFilter).AllRows);
    $b4e14b6b8da86996$var$datatable.deleteRows(toRemove);
    // Find if we have any active event. If not, add a marker for today.
    let hasActiveEvent = false;
    $b4e14b6b8da86996$var$datatable.forEach(function(row) {
        if ($b4e14b6b8da86996$export$b8c8a36935818786(new Date(), row) && !row.is_today_marker && row.public) hasActiveEvent = true;
    }, (0, $hKsEd.ForEachFilter).AllRows);
    if (!hasActiveEvent) {
        const todayMarker = {
            description: $b4e14b6b8da86996$var$currentLanguage.no_event_today,
            event_id: (0, $ef87980efebb2b46$export$c267c46649295c8f)(20),
            first_date: (0, $6dhn9.FormatDate)(new Date(), 'yyyy-mm-dd'),
            last_date: (0, $6dhn9.FormatDate)(new Date(), 'yyyy-mm-dd'),
            is_today_marker: true,
            organizer: '',
            public: true,
            race_type: ''
        };
        $b4e14b6b8da86996$var$datatable.upsertRow(todayMarker);
    }
}
function $b4e14b6b8da86996$var$StartListeners() {
    $b4e14b6b8da86996$var$webSocket = new (0, $gzR1g.NewWebsocket)('events', [
        'events'
    ], false);
    $b4e14b6b8da86996$var$webSocket.DataReceived = function(collectionName, data, fullReload) {
        if (collectionName != 'events') return;
        const changes = data;
        if (fullReload) $b4e14b6b8da86996$var$datatable.clear();
        if (changes.delete != null) {
            const rowIds = [];
            for (const row of changes.delete)rowIds.push(row[0]);
            $b4e14b6b8da86996$var$datatable.deleteRows(rowIds);
        }
        if (changes.upsert != null) $b4e14b6b8da86996$var$datatable.upsertRows(changes.upsert);
        $b4e14b6b8da86996$var$AddTodayMarking();
        $b4e14b6b8da86996$var$datatable.newDraw();
    };
}
function $b4e14b6b8da86996$var$ReCreateDataTable() {
    var data = [];
    if ($b4e14b6b8da86996$var$datatable !== null) {
        data = $b4e14b6b8da86996$var$datatable.data();
        $b4e14b6b8da86996$var$datatable.clear();
    }
    document.getElementById('index-table').innerHTML = '';
    let columns = [
        {
            'data': 'description',
            'title': $b4e14b6b8da86996$var$currentLanguage.index_race_description,
            'render': $b4e14b6b8da86996$var$UrlRender
        },
        {
            'data': 'race_type',
            'title': $b4e14b6b8da86996$var$currentLanguage.index_race_type,
            'render': $b4e14b6b8da86996$var$UrlRender
        },
        {
            'data': 'organizer',
            'title': $b4e14b6b8da86996$var$currentLanguage.index_race_organizer,
            'render': $b4e14b6b8da86996$var$UrlRender
        },
        {
            'data': 'first_date',
            'title': $b4e14b6b8da86996$var$currentLanguage.index_race_date,
            'render': $b4e14b6b8da86996$var$EventDateRender,
            'sortType': (0, $hKsEd.ColumnTypeEnum).Number
        }
    ];
    $b4e14b6b8da86996$var$datatable = new (0, $hKsEd.ErikTable)('index-table', {
        'columns': columns,
        'data': data,
        'id': 'event_id',
        'sort': [
            {
                sort_direction: (0, $hKsEd.SortDirection).Descending,
                column_idx: columns.length - 1
            }
        ],
        'filter': function(event) {
            return event.public;
        },
        'conditionalRowStyling': $b4e14b6b8da86996$var$RowStyle
    });
    $b4e14b6b8da86996$var$AddTodayMarking();
    $b4e14b6b8da86996$var$datatable.newDraw();
}
function $b4e14b6b8da86996$var$UrlRender(data, row, type) {
    if (type == (0, $hKsEd.RenderTypeEnum).Sort) return data;
    if (row.is_today_marker) return '<i>' + data + '</i>';
    return '<a href="event.html?event_id=' + row.event_id + '">' + data + '</a>';
}
function $b4e14b6b8da86996$var$EventDateRender(_, row, type) {
    if (type == (0, $hKsEd.RenderTypeEnum).Sort) return Date.parse(row.first_date);
    if (row.is_today_marker) return '';
    const firstDate = new Date(row.first_date);
    const lastDate = new Date(row.last_date);
    let output = '';
    if (firstDate.valueOf() == lastDate.valueOf()) output = (0, $6dhn9.FormatDate)(firstDate, 'dd.mm.yyyy');
    else if (firstDate.getFullYear() != lastDate.getFullYear()) output = (0, $6dhn9.FormatDate)(firstDate, 'dd.mm.yyyy') + '-' + (0, $6dhn9.FormatDate)(lastDate, 'dd.mm.yyyy');
    else if (firstDate.getMonth() != lastDate.getMonth()) output = (0, $6dhn9.FormatDate)(firstDate, 'dd.mm') + '-' + (0, $6dhn9.FormatDate)(lastDate, 'dd.mm.yyyy');
    else output = (0, $6dhn9.FormatDate)(firstDate, 'dd.') + '-' + (0, $6dhn9.FormatDate)(lastDate, 'dd.mm.yyyy');
    return $b4e14b6b8da86996$var$UrlRender(output, row, type);
}
function $b4e14b6b8da86996$var$IsSameOrAfter(a, b) {
    return a.valueOf() >= b.valueOf();
}
function $b4e14b6b8da86996$var$IsSameOrBefore(a, b) {
    return a.valueOf() <= b.valueOf();
}
function $b4e14b6b8da86996$var$RowStyle(data) {
    var out = [];
    if ($b4e14b6b8da86996$export$b8c8a36935818786(new Date(), data)) out.push('active-event');
    return out;
}
function $b4e14b6b8da86996$export$b8c8a36935818786(now, event) {
    const today = new Date((0, $6dhn9.FormatDate)(now, 'yyyy-mm-dd'));
    const firstDate = (0, $6dhn9.ParseDateOnly)(event.first_date);
    const lastDate = (0, $6dhn9.ParseDateOnly)(event.last_date);
    return $b4e14b6b8da86996$var$IsSameOrAfter(today, firstDate) && $b4e14b6b8da86996$var$IsSameOrBefore(today, lastDate);
}


//# sourceMappingURL=web.b41ffa0b.js.map
